import createDropdownContext from "@/providers/dropdown-provider/dropdown-provider";
import { DropdownSelectorOption } from "@/components/pages/home/components/searchbar/components/dropdown";

export const {
  useDropdownContext: useCategoriesDropdownContext,
  DropdownProvider: CategoriesDropdownProvider,
} = createDropdownContext<DropdownSelectorOption>();
